import authReducer from "../authReducer";
import userReducer from "../userReducer";
import jobReducer from "../jobReducer";
import entiteReducer from "../entiteReducer";
import sidebarMenuReducer from "../sidebarMenuReducer";
import roleReducer from "../roleReducer";
import companyReducer from "../companyReducer";
import emailReducer from "../emailReducer";
import notificationReducer from "../notificationReducer";
import notificationSettingsReducer from "../notificationSettingsReducer";
import taskSettingsReducer from "../taskSettingsReducer";
import applicationLogReducer from "../applicationLogReducer";
import kpiReducer from "../kpiReducer";
import reportReducer from "../reportReducer";

const administrationReducers = {
  auth: authReducer,
  user: userReducer,
  jobs: jobReducer,
  entite: entiteReducer,
  sidebarMenus: sidebarMenuReducer,
  role: roleReducer,
  companies: companyReducer,
  emails: emailReducer,
  notification: notificationReducer,
  notificationSettings: notificationSettingsReducer,
  taskSettings: taskSettingsReducer,
  applicationLog: applicationLogReducer,
  kpi: kpiReducer,
  reports: reportReducer,
};

export default administrationReducers;
